import React from 'react';
import MuiTable from 'components/molecules/MuiTable';
import { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import textLabels from 'utils/MUIDataTableTextLabels';
import CustomToolbar from 'components/molecules/CustomToolBarMuiDatatable/CustomToolbarMuiDatatable';
import { Button, Grid } from '@material-ui/core';
import { IWareHouseList } from 'interfaces/imWarehouse.interface';

interface Props {
  IMWarehouseList: IWareHouseList[];
  isLoading: boolean;
  handleOnClickEditWarehouse: (wareHouseId: string) => void;
  handleOnClickDeleteWarehouse: (wareHouseId: string) => void;
  addWareHouseButton: () => void;
}
export default function IMWarehouseList({
  IMWarehouseList,
  addWareHouseButton,
  isLoading,
  handleOnClickEditWarehouse,
  handleOnClickDeleteWarehouse
}: Props) {
  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: 'id',
      options: {
        display: 'false'
      }
    },
    {
      name: 'name',
      label: 'Bodega'
    },
    {
      name: 'phone',
      label: 'Teléfono'
    },
    {
      name: 'address',
      label: 'Dirección'
    },
    {
      name: 'email',
      label: 'Email'
    },
    {
      name: '',
      label: 'Acciones',
      options: {
        filter: false,
        sort: false,
        download: false,
        print: false,
        empty: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <Grid container justify="flex-start">
              <Button
                variant="outlined"
                size="small"
                color="primary"
                style={{ marginRight: 5 }}
                onClick={() => {
                  handleOnClickEditWarehouse(tableMeta.rowData[0]);
                }}
              >
                Editar
              </Button>
              <Button
                variant="outlined"
                size="small"
                color="default"
                onClick={() => {
                  handleOnClickDeleteWarehouse(tableMeta.rowData[0]);
                }}
              >
                Eliminar
              </Button>
            </Grid>
          );
        }
      }
    }
  ];

  const options: MUIDataTableOptions = {
    textLabels,
    download: false,
    filter: false,
    print: false,
    selectableRowsHeader: false,
    selectableRows: 'none',
    viewColumns: false,
    searchOpen: true,
    customToolbar: () => {
      return <CustomToolbar tooltip="Agregar bodega" onClick={addWareHouseButton} />;
    }
  };

  return (
    <div>
      <MuiTable
        title="Listado de Bodegas"
        isLoading={isLoading}
        columns={columns}
        data={IMWarehouseList}
        options={options}
      />
    </div>
  );
}
